import { createStyles, Theme } from '@material-ui/core/styles'

export default (theme: Theme) =>
	createStyles({
		headerContainer: {
			height: 60,
			background: '#f4f4f9',
			borderBottom: `1px solid ${theme.palette.grey[200]}`,
			display: 'flex',
			flexDirection: 'row',
			alignItems: 'center',
			justifyContent: 'center',
			position: 'fixed',
			top: 0,
			width: '100%',
			[theme.breakpoints.down('sm')]: {
				padding: `0px ${theme.spacing(1)}px`,
			},
			boxShadow: '0px 3px 10px 0px rgba(0,0,0,0.2)',
		},
		titleSection: {
			display: 'flex',
			alignItems: 'center',
			flexDirection: 'row',
			width: '650px',
		},
		headerTitle: {
			fontSize: '24px',
			fontWeight: 'bold',
			color: '#1B1A7C',
			paddingLeft: '8px',
		},
		companyJobContainer: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			flexDirection: 'row',
			marginLeft: 'auto',
			'& > svg': {
				fill: theme.palette.grey[800],
			},
			background: '#fff',
			borderRadius: '30px',
			padding: '3px',
		},
		postAsSection: {
			cursor: 'default',
			display: 'flex',
			flexDirection: 'column',
			marginLeft: '3px',
		},
		postAsText: {
			color: theme.palette.grey[800],
		},
		jobCompany: {
			color: theme.palette.grey[800],
		},
		activeJobCompany: {
			color: '#1B1A7C',
			fontWeight: 500,
		},
		companyLogo: {
			width: '35px',
			height: '35px',
			minWidth: '35px',
			background: '#fff',
		},
		closeButton: {
			display: 'block',
			position: 'absolute',
			left: '10px',
			width: 24,
			height: 24,
			padding: 0,
			[theme.breakpoints.down('sm')]: {
				left: 0,
				right: '10px',
			},
		},
		popper: {
			zIndex: 1,
			marginTop: 15,
			minWidth: 150,
			'& > div': {
				borderRadius: 8,
			},
			'& $arrow': {
				top: 0,
				left: 'auto',
				right: theme.spacing(1.5),
				marginTop: '-0.9em',
				width: '3em',
				height: '1em',
				'&::before': {
					borderWidth: '0 1em 1em 1em',
					borderColor: `transparent transparent ${theme.palette.common.white} transparent`,
				},
			},
		},
		arrow: {
			position: 'absolute',
			fontSize: 7,
			width: '3em',
			height: '3em',
			'&::before': {
				content: '""',
				margin: 'auto',
				display: 'block',
				width: 0,
				height: 0,
				borderStyle: 'solid',
			},
		},
	})
